import React from 'react';

import Paginator from '../search/components/results/paginator';
import EmptyState from '../empty_state';
import CallListOffMarketResultCard from './call_list_off_market_result_card';
import { useSelector } from 'react-redux';
import { selectCallListItems, selectTotalPages } from '../store/selectors/results';
import { selectLoading } from '../store/selectors/ui';
import { faRectangleHistoryCircleUser } from '@fortawesome/pro-solid-svg-icons';

type CallListOffMarketResultsCardListProps = {
  containerRef: React.MutableRefObject<null | HTMLDivElement>;
  selectAll: boolean;
  selectedCallListItemIds: Set<number>;
  onSelectToggle: (callListItemId: number) => void;
  lastUpdatedMap?: Map<number, Date>;
}

export default function CallListOffMarketResultsCardList(
  {
    containerRef,
    selectAll,
    selectedCallListItemIds,
    onSelectToggle,
    lastUpdatedMap
  }: CallListOffMarketResultsCardListProps) {
  const callListItems = useSelector(selectCallListItems);
  const totalPages = useSelector(selectTotalPages);
  const loading = useSelector(selectLoading);

  return (
    <div className="h-100 overflow-auto position-relative z-2" ref={containerRef}>
      {callListItems.length > 0 && (
        <>
          <div className={`mt-1 p-3 transition-opacity ${loading ? 'opacity-75' : 'opacity-100'}`}>
            {callListItems.map(item => (
              <CallListOffMarketResultCard
                callListItem={item}
                isSelected={selectAll || selectedCallListItemIds.has(item.id)}
                key={item.id}
                lastUpdated={lastUpdatedMap ? lastUpdatedMap[item.id] : undefined}
                onSelectToggle={onSelectToggle}
              />
            ))}
          </div>

          {totalPages > 1 &&
            <div className="d-flex justify-content-center mb-4">
              <Paginator containerRef={containerRef} />
            </div>
          }
        </>
      )}
      {(callListItems.length === 0 && !loading) && (
        <div>
          <EmptyState icon={faRectangleHistoryCircleUser}
            iconSize="2x"
            text="Add properties to this call list to see them here."
            title="No items in this call list"
          />
        </div>
      )}
    </div>
  );
}
